export default __webpack_public_path__ + "static/media/alter_image.9999920b.webp";